export const translations = {
  vi: {
    // Nav
    'nav.home': 'Trang chủ',
    'nav.products': 'Sản phẩm',
    'nav.story': 'Câu chuyện',
    'nav.sale': 'Sale & Ưu đãi',
    'nav.contact': 'Cửa hàng',
    'nav.login': 'Đăng nhập',
    'nav.logout': 'Đăng xuất',
    'nav.admin': 'Quản trị',
    // Home sections
    'home.hot': 'Hot theo mùa',
    'home.best': 'Best seller',
    'home.limited': 'Limited season',
    'home.sale': 'Đang giảm giá',
    'home.combo': 'Combo quà tặng',
    'home.favorite': 'Life in Nha Trang favorite',
    'home.viewAll': 'Xem tất cả',
    'home.cta': 'Khám phá sản phẩm',
    // Product
    'p.addToCart': 'Thêm vào giỏ',
    'p.added': 'Đã thêm!',
    'p.includes': 'Gồm',
    'p.search': 'Tìm sản phẩm...',
    'p.sort.newest': 'Mới nhất',
    'p.sort.priceAsc': 'Giá thấp → cao',
    'p.sort.priceDesc': 'Giá cao → thấp',
    'p.all': 'Tất cả',
    'p.combos': 'Combo',
    'p.empty': 'Không tìm thấy sản phẩm phù hợp.',
    'p.stock': 'Còn hàng',
    // Badges
    'b.hot': 'Hot mùa này',
    'b.best': 'Best seller',
    'b.limited': 'Limited',
    'b.sale': 'Sale',
    'b.fav': 'Favorite',
    // Sale page
    'sale.title': 'Sale & Ưu đãi',
    'sale.promos': 'Chương trình đang chạy',
    'sale.today': 'Chỉ hôm nay',
    'sale.tiers': 'Mua càng nhiều, ưu đãi càng lớn',
    'sale.tierFrom': 'Đơn từ',
    'sale.shopNow': 'Mua ngay',
    // Contact
    'contact.title': 'Ghé cửa hàng',
    'contact.address': 'Địa chỉ',
    'contact.phone': 'Điện thoại',
    'contact.hours': 'Giờ mở cửa',
    'contact.email': 'Email',
    // Cart & checkout
    'cart.title': 'Giỏ hàng',
    'cart.empty': 'Giỏ hàng đang trống.',
    'cart.subtotal': 'Tạm tính',
    'cart.discount': 'Giảm giá',
    'cart.total': 'Tổng cộng',
    'cart.checkout': 'Đặt hàng — giao tới khách sạn',
    'cart.continue': 'Tiếp tục mua sắm',
    'cart.remove': 'Xoá',
    'offer.reached': 'Bạn đã đạt ưu đãi:',
    'offer.next': 'Mua thêm {amount} để nhận:',
    'offer.suggest': 'Gợi ý thêm vào giỏ:',
    'co.title': 'Thanh toán & giao tới khách sạn',
    'co.name': 'Họ tên',
    'co.phone': 'Số điện thoại / Zalo / WhatsApp',
    'co.email': 'Email (không bắt buộc)',
    'co.hotel': 'Tên khách sạn',
    'co.room': 'Số phòng',
    'co.address': 'Địa chỉ khác (nếu không ship khách sạn)',
    'co.time': 'Giờ nhận mong muốn',
    'co.payment': 'Phương thức thanh toán',
    'co.cod': 'Tiền mặt khi nhận hàng (COD)',
    'co.bank': 'Chuyển khoản QR',
    'co.qrNote': 'Quét QR để chuyển khoản. Đơn được giao sau khi cửa hàng xác nhận đã nhận tiền.',
    'co.placeOrder': 'Xác nhận đặt hàng',
    'co.placing': 'Đang gửi đơn...',
    'co.required': 'Vui lòng điền họ tên, SĐT và tên khách sạn (hoặc địa chỉ).',
    'co.note': 'Ghi chú cho cửa hàng',
    'ok.title': 'Đặt hàng thành công!',
    'ok.body': 'Cảm ơn bạn! Nhân viên Life in Nha Trang sẽ liên hệ xác nhận và giao tới khách sạn của bạn trong hôm nay.',
    'ok.code': 'Mã đơn',
    'ok.back': 'Về trang chủ',
    // Auth
    'auth.email': 'Email',
    'auth.password': 'Mật khẩu',
    'auth.fullName': 'Họ tên',
    'auth.login': 'Đăng nhập',
    'auth.register': 'Đăng ký',
    'auth.noAccount': 'Chưa có tài khoản?',
    'auth.hasAccount': 'Đã có tài khoản?',
    'auth.checkEmail': 'Kiểm tra email để xác nhận tài khoản (nếu được yêu cầu), sau đó đăng nhập.',
    // Chat
    'chat.title': 'Tư vấn quà tặng',
    'chat.open': 'Mở tư vấn quà tặng',
    // Footer
    'footer.tagline': 'Quà tặng & đặc sản Nha Trang — giao tận khách sạn.',
    // Misc
    'misc.loading': 'Đang tải...',
    'misc.error': 'Không tải được dữ liệu. Vui lòng thử lại.',
  },
  en: {
    'nav.home': 'Home',
    'nav.products': 'Products',
    'nav.story': 'Our Story',
    'nav.sale': 'Sale & Offers',
    'nav.contact': 'Visit Us',
    'nav.login': 'Log in',
    'nav.logout': 'Log out',
    'nav.admin': 'Admin',
    'home.hot': 'Hot this season',
    'home.best': 'Best sellers',
    'home.limited': 'Limited season',
    'home.sale': 'On sale',
    'home.combo': 'Gift combos',
    'home.favorite': 'Life in Nha Trang favorites',
    'home.viewAll': 'View all',
    'home.cta': 'Browse products',
    'p.addToCart': 'Add to cart',
    'p.added': 'Added!',
    'p.includes': 'Includes',
    'p.search': 'Search products...',
    'p.sort.newest': 'Newest',
    'p.sort.priceAsc': 'Price low → high',
    'p.sort.priceDesc': 'Price high → low',
    'p.all': 'All',
    'p.combos': 'Combos',
    'p.empty': 'No matching products found.',
    'p.stock': 'In stock',
    'b.hot': 'Hot now',
    'b.best': 'Best seller',
    'b.limited': 'Limited',
    'b.sale': 'Sale',
    'b.fav': 'Favorite',
    'sale.title': 'Sale & Offers',
    'sale.promos': 'Running promotions',
    'sale.today': 'Today only',
    'sale.tiers': 'Buy more, save more',
    'sale.tierFrom': 'Orders from',
    'sale.shopNow': 'Shop now',
    'contact.title': 'Visit our store',
    'contact.address': 'Address',
    'contact.phone': 'Phone',
    'contact.hours': 'Opening hours',
    'contact.email': 'Email',
    'cart.title': 'Your cart',
    'cart.empty': 'Your cart is empty.',
    'cart.subtotal': 'Subtotal',
    'cart.discount': 'Discount',
    'cart.total': 'Total',
    'cart.checkout': 'Checkout — deliver to my hotel',
    'cart.continue': 'Continue shopping',
    'cart.remove': 'Remove',
    'offer.reached': 'You unlocked:',
    'offer.next': 'Add {amount} more to get:',
    'offer.suggest': 'Quick add suggestions:',
    'co.title': 'Checkout & hotel delivery',
    'co.name': 'Full name',
    'co.phone': 'Phone / Zalo / WhatsApp',
    'co.email': 'Email (optional)',
    'co.hotel': 'Hotel name',
    'co.room': 'Room number',
    'co.address': 'Other address (if not a hotel)',
    'co.time': 'Preferred delivery time',
    'co.payment': 'Payment method',
    'co.cod': 'Cash on delivery (COD)',
    'co.bank': 'Bank transfer via QR',
    'co.qrNote': 'Scan the QR to pay. Your order ships once the store confirms the payment.',
    'co.placeOrder': 'Place order',
    'co.placing': 'Placing order...',
    'co.required': 'Please fill in your name, phone and hotel name (or address).',
    'co.note': 'Note for the store',
    'ok.title': 'Order placed!',
    'ok.body': 'Thank you! Our staff will contact you to confirm and deliver to your hotel today.',
    'ok.code': 'Order code',
    'ok.back': 'Back to home',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.fullName': 'Full name',
    'auth.login': 'Log in',
    'auth.register': 'Sign up',
    'auth.noAccount': "Don't have an account?",
    'auth.hasAccount': 'Already have an account?',
    'auth.checkEmail': 'Check your email to confirm (if required), then log in.',
    'chat.title': 'Gift advisor',
    'chat.open': 'Open gift advisor',
    'footer.tagline': 'Nha Trang gifts & specialties — delivered to your hotel.',
    'misc.loading': 'Loading...',
    'misc.error': 'Could not load data. Please try again.',
  },
};
